import App from 'app/app.js';

function LtPhotoDayRedirection() {
  return {
    restrict: 'E',
    scope: {
      onCancel: '&',
      onEmit: '&'
    },
    template:
      '    <div class="modal-body" ng-init="photoDay.init()" lt-drawer="photoDay.visible" lt-drawer-cancellation="photoDay.close(); onCancel()">' +
      '        <div class="photo-day">' +
      '           <div class="main">' +
      '               <lt-icon name="fa-sharp-solid-times" ng-click="photoDay.close()"></lt-icon>' +
      '               <div class="title" lt-translate="PARTNER_CODE"></div>' +
      '           </div>' +
      '           <div class="detail">' +
      '               <div class="desc" lt-translate="PARTNER_LINK"></div>' +
      '               <button lt-translate="TAKE_ME_THERE" class="btn" ng-click="onEmit(); photoDay.close()"></button>' +
      '               <div class="close-action" lt-translate="DISMISS" ng-click="photoDay.close(); onCancel()"></div>' +
      '           </div>' +
      '        </div>' +
      '    </div>',
    controller: function () {
      this.visible = false;

      this.init = function () {
        this.visible = true;
      };
      this.close = function () {
        this.visible = false;
      };
    },
    controllerAs: 'photoDay'
  };
}

App.directive('ltPhotoDayRedirection', [LtPhotoDayRedirection]);
